import React, { useState } from "react";
import { resetPassword, ResetPasswordResponse, authErrorMessage } from "@/api/auth_api.ts";
import { useLocation, useSearch } from "wouter";
import { AxiosError } from "axios";
import { Input } from "@/components/ui/input.tsx";
import { Errors, FormError } from "@/pages/RegistrationPage.tsx";
import { Button } from "@/components/ui/button.tsx";
import { loginState } from "@/states.ts";

const ResetPasswordPage: React.FC = (props) => {
	const [password, setPassword] = useState("");
	const [password2, setPassword2] = useState("");
	const [errors, setErrors] = useState<ResetPasswordResponse["errors"]>(undefined);
	const [formError, setFormError] = useState<string>();
	const [location, setLocation] = useLocation();
	const query = useSearch();

	const handleSubmit = async (e: React.BaseSyntheticEvent) => {
		e.preventDefault();
		setErrors({});
		setFormError(undefined);

		try {
			const params = new URLSearchParams(query);
			const token = params.get("token") || "";
			const uuid = params.get("uuid") || "";

			const response = await resetPassword(token, uuid, password, password2);
			if (response.ok && response.token) {
				loginState.token = response.token;
				setLocation("/");
			}
		} catch (e) {
			if (e instanceof AxiosError && e.response?.data?.errors) {
				setErrors(e.response.data.errors);
			}
			setFormError(authErrorMessage(e));
			return;
		}
	};

	return (
		<div className={"flex justify-center items-center h-screen"}>
			<form
				onSubmit={handleSubmit}
				target={"#"}
				className={"flex flex-col gap-4 flex-1 w-full max-w-[300px] p-4"}
			>
				<h2 className={"text-xl font-bold"}>Reset Password</h2>
				<FormError error={formError} />
				<label>
					Password
					<Input
						type="password"
						name={"password"}
						value={password}
						onChange={(e) => setPassword(e.target.value)}
					/>
					<Errors errors={errors} field={"password"} />
				</label>
				<label>
					Confirm Password
					<Input
						type="password"
						name={"password2"}
						value={password2}
						onChange={(e) => setPassword2(e.target.value)}
					/>
					<Errors errors={errors} field={"password2"} />
				</label>
				<div className={"flex justify-between items-center"}>
					<Button type={"submit"} className={"w-full sm:w-6/12"}>
						Reset Password
					</Button>
				</div>
			</form>
		</div>
	);
};

export { ResetPasswordPage };
